import { Component, Input, Output, EventEmitter, ElementRef, HostListener, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-driver-select',
  templateUrl: './driver-select.component.html',
  styleUrls: ['./driver-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DriverSelectComponent),
      multi: true
    }
  ]
})
export class DriverSelectComponent implements ControlValueAccessor {
  @Input() options: any[] = [];
  @Input() placeholder: string = 'Select Driver';
  @Input() disabled: boolean = false;
  @Input() dropup: boolean = false;

  @Output() selectionChange = new EventEmitter<any>();

  selectedValue: any = null;
  selectedLabel: string = '';
  isDropdownOpen: boolean = false;
  isInvalidDriver: boolean = false;

  private onChange: any = () => { };
  private onTouched: any = () => { };

  constructor(private elementRef: ElementRef) { }

  toggleDropdown() {
    if (!this.disabled) {
      this.isDropdownOpen = !this.isDropdownOpen;
    }
  }

  selectOption(option: any) {
    this.selectedValue = option.id;
    this.isInvalidDriver = false;
    if (option.id === 'all') {
      this.selectedLabel = 'All Drivers';
    } else {
      this.selectedLabel = option.id ? `${option.first_name} ${option.last_name}` : 'None';
    }
    this.isDropdownOpen = false;

    this.onChange(this.selectedValue);
    this.onTouched();
    this.selectionChange.emit(option);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.selectedValue = value;
    this.isInvalidDriver = false;

    if (value === 'all') {
      this.selectedLabel = 'All Drivers';
      return;
    }

    const selected = this.options.find(opt => String(opt.id) === String(value));
    if (selected) {
      if (selected.id === 'all') {
        this.selectedLabel = 'All Drivers';
      } else {
        this.selectedLabel = selected.id ? `${selected.first_name} ${selected.last_name}` : 'None';
      }
    } else if (value === 0 || value === '0') {
      this.selectedLabel = 'None';
    } else if (typeof value === 'string' && value.trim().length > 0 && isNaN(Number(value))) {
      this.selectedLabel = value;
      this.isInvalidDriver = true;
    } else {
      this.selectedLabel = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
